<div id="admin-questionnarie-create" class="page-layout carded  fullwidth" fxLayout="column">
  <ngx-loading [show]="loading"></ngx-loading>
  <!-- HEADER -->
  <div class="header accent p-24 h-70" fxLayout="row" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutAlign="center start">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="secondary-text s-18">home</mat-icon>
        <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
        <span class="secondary-text">Chestionare</span>
        <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
        <span class="secondary-text" *ngIf="createNewEntity">Chestionar nou</span>
        <span class="secondary-text" *ngIf="!createNewEntity">Editare chestionar</span>

      </div>
      <div class="h1 mt-16" *ngIf="createNewEntity">Adaugare chestionar nou</div>
      <div class="h1 mt-16" *ngIf="!createNewEntity">Modificare chestionar</div>
    </div>
  </div>
  <!-- / HEADER -->
  
  <div class="content p-24">
    <div class="mat-elevation-z8">
      <div style="max-width: 100%!important;">

        <mat-card fxFlex="100" class="mt-10">

          <mat-card-content>

            <form [formGroup]="questionnaireForm" fxLayout="row" style="max-width: 100%!important;" class="p-24">

              <mat-form-field appearance="standard" fxFlex="33" class="pr-4">
                <mat-label>Denumire chestionar</mat-label>
                <input matInput formControlName="name">
                <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
                <mat-error *ngIf="questionnaireForm.get('name').errors?.serverError">{{ questionnaireForm.get('name').errors?.serverError }}</mat-error>
              </mat-form-field>

              <mat-form-field appearance="standard" fxFlex="33" class="pr-4">
                <mat-label>Pentru utilizatorul</mat-label>
                <mat-select formControlName="forUser" style="width: 100%!important;" [(ngModel)]="selectedUser" [compareWith]="compareObjects">
                  <mat-option> - </mat-option>
                  <mat-option *ngFor="let user of listOfUsers" [value]="user">{{user.name}}</mat-option>
                </mat-select>
              </mat-form-field>

              <div class="checkBoxWrapper pr-4" fxFlex="33">
                <mat-checkbox formControlName="implicit" [checked]="false" (change)="onImplicitChange($event)">Chestionar implicit pentru toti utilizatorii</mat-checkbox>
              </div>

            </form>


            <admin-question-row class="p-24 mb-4" fxLayout="row" style="width: 100%!important"
                *ngFor="let question of questionsList" [question]="question" (deleteQuestionEvent)="onDeleteQuestion($event)" (updateQuestionEvent)="onUpdateQuestion($event)">>
            </admin-question-row>

            <div class="p-24 mb-4" style="width: 100%!important; justify-content: flex-end;">
              <button mat-raised-button color="accent" (click)="addNewQuestion()">Adauga intrebare noua</button>
            </div>


          </mat-card-content>

          <mat-card-actions style="text-align: right; padding: 10px">
            <button mat-raised-button color="accent" (click)="onSaveQuestionnaire()">Salveaza</button>
          </mat-card-actions>

        </mat-card>

      </div>
    </div>
  </div>

</div>
